<template>
  <div class="d-flex flex-column gap-12 mb-6">
    <!-- <span>
        <Button
                theme="4"
                min-width="120px"
                @onClick="autoField()"
              >
                autoField - step 1
              </Button>
    </span> -->
  
    <divcard>
      <div class="card-part pt-0">
        <div class="txt-head black--text mb-2">
          <span class="theme-color-one">ส่วนที่ 1 :</span> ข้อมูลทั่วไป
        </div>

        <!-- Form 1 -->
        <div>

<!--          doc_type-->
<!--          <div class="flex-center gap-16" v-if="form.status === 'Progress/Final'">-->
<!--            <div class="flex">-->
<!--              <div class="mb-1 black&#45;&#45;text">-->
<!--                ประเภทเอกสาร-->
<!--                <span class="theme-color-seven txt-normal">(โปรดระบุ)</span>-->
<!--              </div>-->
<!--              <v-radio-group :value="form.doc_type" @change="setFormField('doc_type', $event)" row>-->
<!--                <v-radio-->
<!--                    color="#f15a29"-->
<!--                    label="Progress"-->
<!--                    value="Progress"-->
<!--                ></v-radio>-->
<!--                <v-radio-->
<!--                    color="#f15a29"-->
<!--                    label="Final"-->
<!--                    value="Final"-->
<!--                ></v-radio>-->
<!--              </v-radio-group>-->
<!--            </div>-->
<!--          </div>-->
          <!-- Form 1 #line1 -->
          <div class="flex-center gap-16">
            <div class="flex">
              <div class="mb-1 black--text">
                อุทยานวิทยาศาสตร์
                <span class="theme-color-seven txt-normal">(โปรดระบุ)</span>
              </div>
              <TextField
                  theme="3"
                  :readonly="isOIC"
                  :value="form.sci_park"
                  @onChange="setFormField('sci_park', $event)"
              ></TextField>
            </div>
          </div>

          <!-- Form 1 #line2 -->
          <div class="flex-center gap-16">
            <div class="flex">
              <div class="mb-1 black--text">
                ชื่อ - สกุล ผู้รับผิดชอบโครงการ
                <span class="theme-color-seven txt-normal">(โปรดระบุ)</span>
              </div>
              <TextField
                  theme="3"
                  :readonly="isOIC"
                  :value="form.pm_name"
                  @onChange="setFormField('pm_name', $event)"
              ></TextField>
            </div>
          </div>

          <!-- Form 1 #line3 -->
          <div class="flex-center gap-16">
            <div class="flex">
              <div class="mb-1 black--text">
                ตำแหน่ง
                <span class="theme-color-seven txt-normal">(โปรดระบุ)</span>
              </div>
              <AutoBox
                  theme="3"
                  :readonly="isOIC"
                  :items="masterData.positions"
                  item-text="name"
                  item-value="name"
                  :value="form.pm_position"
                  @onChange="setFormField('pm_position', $event)"
              ></AutoBox>
            </div>
          </div>

          <!-- Form 1 #line4 -->
          <div class="flex-center gap-16">
            <div class="flex">
              <div class="mb-1 black--text">
                หน่วยงาน
              </div>
              <AutoBox
                  theme="3"
                  :readonly="isOIC"
                  :items="masterData.institutes"
                  item-text="name"
                  item-value="name"
                  :value="form.pm_org"
                  @onChange="setFormField('pm_org', $event)"
              ></AutoBox>
            </div>
          </div>

          <div class="flex-center gap-16">
            <div class="flex">
              <div class="mb-1 black--text">
                โทรศัพท์
<!--                <span class="theme-color-seven txt-normal">(โปรดระบุ)</span>-->
              </div>
              <TextField
                  placeholder="02XXXXXXX"
                  theme="3"
                  :readonly="isOIC"
                  input-type="number"
                  :value="form.pm_phone"
                  @onChange="setFormField('pm_phone', $event)"
              ></TextField>
            </div>

            <div class="flex">
              <div class="mb-1 black--text">
                โทรสาร
<!--                <span class="theme-color-seven txt-normal">(โปรดระบุ)</span>-->
              </div>
              <TextField
                  theme="3"
                  :readonly="isOIC"
                  input-type="number"
                  :value="form.pm_fax"
                  @onChange="setFormField('pm_fax', $event)"
              ></TextField>
            </div>
          </div>

          <div class="flex-center gap-16">
            <div class="flex">
              <div class="mb-1 black--text">
                โทรศัพท์มือถือ
                <span class="theme-color-seven txt-normal">(โปรดระบุ)</span>
              </div>
              <TextField
                  placeholder="09XXXXXXXX"
                  theme="3"
                  :readonly="isOIC"
                  input-type="number"
                  :rules="mobilePhoneRules"
                  :value="form.pm_mobile_phone"
                  @onChange="setFormField('pm_mobile_phone', $event)"
              ></TextField>
            </div>

            <div class="flex">
              <div class="mb-1 black--text">
                E-mail
                <span class="theme-color-seven txt-normal">(โปรดระบุ)</span>
              </div>
              <TextField
                  theme="3"
                  :readonly="isOIC"
                  :rules="emailRules"
                  :value="form.pm_email"
                  @onChange="setFormField('pm_email', $event)"
              ></TextField>
            </div>
          </div>

        </div>

      </div>


      <div class="card-part">
        <div>
          <div class="flex-center gap-16">
            <div class="flex">
              <div class="mb-1 black--text">
                ชื่อ - สกุล ผู้ประสานงานโครงการ
                <span class="theme-color-seven txt-normal">(โปรดระบุ)</span>
              </div>
              <TextField
                  theme="3"
                  :readonly="isOIC"
                  :value="form.pc_name"
                  @onChange="setFormField('pc_name', $event)"
              ></TextField>
            </div>
          </div>

          <div class="flex-center gap-16">
            <div class="flex">
              <div class="mb-1 black--text">
                ตำแหน่ง
                <span class="theme-color-seven txt-normal">(โปรดระบุ)</span>
              </div>
              <AutoBox
                  theme="3"
                  :readonly="isOIC"
                  :items="masterData.positions"
                  item-text="name"
                  item-value="name"
                  :value="form.pc_position"
                  @onChange="setFormField('pc_position', $event)"
              ></AutoBox>
            </div>
          </div>

          <div class="flex-center gap-16">
            <div class="flex">
              <div class="mb-1 black--text">
                หน่วยงาน
              </div>
              <AutoBox
                  theme="3"
                  :readonly="isOIC"
                  :items="masterData.institutes"
                  item-text="name"
                  item-value="name"
                  :value="form.pc_org"
                  @onChange="setFormField('pc_org', $event)"
              ></AutoBox>
            </div>
          </div>

          <div class="flex-center gap-16">
            <div class="flex">
              <div class="mb-1 black--text">
                โทรศัพท์
                <!--                <span class="theme-color-seven txt-normal">(โปรดระบุ)</span>-->
              </div>
              <TextField
                  placeholder="02XXXXXXX"
                  theme="3"
                  :readonly="isOIC"
                  input-type="number"
                  :value="form.pc_phone"
                  @onChange="setFormField('pc_phone', $event)"
              ></TextField>
            </div>

            <div class="flex">
              <div class="mb-1 black--text">
                โทรสาร
                <!--                <span class="theme-color-seven txt-normal">(โปรดระบุ)</span>-->
              </div>
              <TextField
                  theme="3"
                  :readonly="isOIC"
                  input-type="number"
                  :value="form.pc_fax"
                  @onChange="setFormField('pc_fax', $event)"
              ></TextField>
            </div>
          </div>

          <div class="flex-center gap-16">
            <div class="flex">
              <div class="mb-1 black--text">
                โทรศัพท์มือถือ
                <span class="theme-color-seven txt-normal">(โปรดระบุ)</span>
              </div>
              <TextField
                  placeholder="09XXXXXXXX"
                  theme="3"
                  :readonly="isOIC"
                  input-type="number"
                  :rules="mobilePhoneRules"
                  :value="form.pc_mobile_phone"
                  @onChange="setFormField('pc_mobile_phone', $event)"
              ></TextField>
            </div>

            <div class="flex">
              <div class="mb-1 black--text">
                E-mail
                <span class="theme-color-seven txt-normal">(โปรดระบุ)</span>
              </div>
              <TextField
                  theme="3"
                  :readonly="isOIC"
                  :rules="emailRules"
                  :value="form.pc_email"
                  @onChange="setFormField('pc_email', $event)"
              ></TextField>
            </div>
          </div>
          <!-- <div class="flex-center gap-16">
            <div class="flex">
              <div class="mb-1 black--text">
                อ้างอิง (Requirement Form)
                <span class="theme-color-seven txt-normal">(โปรดระบุ)</span>
              </div>
              <AutoBox
                  theme="3"
                  :readonly="isOIC"
                  :items="masterData.requirement_form"
                  item-text="doc_no"
                  item-value="id"
                  :value="form.requirement_form_id"
                  @onChange="setFormField('requirement_form_id', $event)"
              ></AutoBox>
            </div>
          </div> -->
        </div>
      </div>
    </divcard>
  </div>
</template>

<script>
import TextField from "../../../components/input/TextField"
import SwitchInset from "../../../components/input/SwitchInset"
import AutoBox from "../../../components/input/AutoBox"
import Button from "../../../components/input/Button"
import {eventBus, validateEmail} from "../../../plugins/global-funcs"
import { mapState } from "vuex"

export default {
  name: "AFormGeneral",
  components: {
    TextField,
    SwitchInset,
    AutoBox,
    Button
  },
  props: {
    masterData: {
      default: () => ({})
    },
    isSameId: {
      default: false
    }
  },
  data () {
    return {
      form: {},
      mobilePhoneRules: [
        (v) => !!v || "",
      ],
      emailRules: [
        (v) => !!v || "",
        (v) => validateEmail(v) || "อีเมลไม่ถูกต้อง",
      ],
    }
  },
  computed: {
    ...mapState({
      GeneralForm: state => state.AForm.GeneralForm,
      isOIC: state => state.Auth.User.user_type === 'สป.อว.'
    })
  },
  created () {
    if (this.isSameId && !this.masterData.form_b) this.form = this.GeneralForm
    this.form.sci_park = this.masterData.region;
    if (this.masterData.form_b) {
      if (this.masterData.form_b.form_ab_general_info) {
        this.form = this.masterData.form_b.form_ab_general_info
      }
    }
    eventBus.$on('aFormGeneral', () => {
      eventBus.$emit('aFormGeneralSend', this.form)
    })

    eventBus.$on('aFormSummary', () => {
      this.$store.commit('AForm/addSummaryData', {
        partOneForm: this.form
      })
    })
    // if(this.form.status === 'Progress/Final' && !this.form.doc_type){
    //   this.form.doc_type = 'Progress'
    // }
    console.log('form', this.form)
  },
  methods: {
    setFormField(field, val) {
      this.form[field] = val
      this.$forceUpdate()
    },
    autoField() {
         this.setFormField("sci_park", "อุทยานวิทยาศาสตร์ประเทศไทย")
    this.setFormField("pm_name", "ตัวอย่างชื่อ - สกุล ผู้รับผิดชอบโครงการ")
    this.setFormField("pm_position", "นักบริหาร")
    this.setFormField("pm_org", "สำนักเลขาธิการคณะรัฐมนตรี")
    this.setFormField("pm_phone", "0888888888")
    this.setFormField("pm_fax", "0888888888")
    this.setFormField("pm_mobile_phone", "0888888888")
    this.setFormField("pm_email", "example@mail.com")

    this.setFormField("pc_name", "ตัวอย่างชื่อ - สกุล ผู้ประสานงานโครงการ")
    this.setFormField("pc_position", "อำนวยการเฉพาะด้าน")
    this.setFormField("pc_org", "สำนักเลขาธิการนายกรัฐมนตรี")
    this.setFormField("pc_phone", "0888888888")
    this.setFormField("pc_fax", "0888888888")
    this.setFormField("pc_mobile_phone", "0888888888")
    this.setFormField("pc_email", "example@mail.com")
    this.masterData.form_b.form_ab_general_info = this.form
    }
  }
}
</script>

<style scoped>

</style>